module.exports = __webpack_public_path__ + "static/media/Illustration_point1.49be675a.svg";